/**
 * Deterministic non-cryptographic hash of a string to a non-negative integer.
 * Stable across runs — use it to pick a stable bucket (avatar colour, fallback image)
 * from an id. djb2-style: h = h * 31 + charCode, kept in 32-bit range.
 */
export const hashId = (id: string): number => {
  let h = 0;
  for (let i = 0; i < id.length; i++) {
    h = (h * 31 + id.charCodeAt(i)) | 0;
  }
  return Math.abs(h);
};
